import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PhonePipe } from '@mt-ng2/common';
import { PublicCheckInDTO } from '../../../model/interfaces/custom/public-check-in-dto';
import { PublicCheckInService } from '../services/public-check-in.service';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-public-check-in-success',
    templateUrl: './public-check-in-success.component.html',
    standalone: false
})
export class PublicCheckInSuccessComponent implements OnInit {
    checkInData: PublicCheckInDTO;
    phoneNumberPipe: PhonePipe = new PhonePipe();
    constructor(private checkInService: PublicCheckInService) {}
    ngOnInit(): void {
        this.checkInService.checkInData.subscribe((response) => {
            this.checkInData = response;
        });
    }
}
